import React, { useState } from 'react'
import HeaderSection from '../HeaderSection'
import Uploadfiles from '../../Screens/UploadFiles/Uploadfiles'
import ExtractingLoader from '../../Screens/ExtractingLoader/ExtractingLoader'
import ResumeParser from '../../Screens/ResumeParser/ResumeParser'

function MenuContainer({ children, headerName, hideHeader, setisToggled, isToggled,enableSideBar,enableProfile }) {



  return (
    <div className="px-3 flex-fill">
      <HeaderSection handleToggleBtn={() => setisToggled(!isToggled)} headerName={headerName} enableSideBar={enableSideBar} enableProfile={enableProfile} />
      {/* <Uploadfiles /> */}
      {/* <ExtractingLoader/> */}
      <div className="main__section bg-white shadow_sm4 overflow-hidden mt-4 w-100  br_15 pt-2">
        <div className={`text-center ${hideHeader ? "d-none" : "d-none"}`}>
          <h2 className="font_22 text_master2 fw-bold mb-3 ">{headerName}</h2>
          {/* <p className="font_14">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, <br/>sed do eiusmod tempor incididunt ut 
              labore et dolore magna aliqua. Gravida quis blandit turpis cursus in hac habitasse.
            </p> */}
        </div>
        {children}

      </div>
    </div>
  )
}

export default MenuContainer
